import TrendingPopover from "@/components/brand_portfolio/TrendingPopover.vue";
import BrandPortfolioMixin from "@/mixins/BrandPortfolioMixin.vue";
export default {
  name: "TrendingValueWithPopover",
  components: {
    TrendingPopover
  },
  mixins: [BrandPortfolioMixin],
  props: {
    portfolio: {
      type: Object,
      default: {}
    },
    trendingType: {
      type: String,
      default: "ytd"
    }
  },
  data() {
    return {
      trendingKeys: {
        ytd: "revenue_ytd_evol_vs_last_year",
        mtd: "revenue_mtd_evol_vs_last_year",
        wtd: "revenue_wtd_evol_vs_last_year"
      }
    };
  },
  computed: {
    processedTrendingValue() {
      return val => {
        if (!val) return "gray";
        return val > 1 ? "green-200" : val > 0.65 ? "green-100" : val > 0.3 ? "green-50" : val > 0 ? "green-25" : val == 0 ? "gray" : val >= -0.3 ? "red-25" : val >= -0.65 ? "red-50" : val > -1 ? "red-100" : "red-200";
      };
    },
    trendingValue() {
      return val => {
        if (!val) return "-";
        const value = (val * 100).toFixed(0);
        return value > 0 ? `+${value}%` : `${value}%`;
      };
    }
  }
};